/** 每条异步通道独立代次，重置同时撤销所有尚未完成的请求。 */
export function createCatalogEpochs() {
  let generation = 0
  const sequences = new Map<string, number>()
  return {
    invalidateAll() { generation++; sequences.clear() },
    invalidate(channel: string) { sequences.set(channel, (sequences.get(channel) ?? 0) + 1) },
    begin(channel: string) {
      const startedGeneration = generation
      const sequence = (sequences.get(channel) ?? 0) + 1
      sequences.set(channel, sequence)
      return () => startedGeneration === generation && sequences.get(channel) === sequence
    },
  }
}

export function isUnavailableCatalogError(error: unknown): boolean {
  if (!error || typeof error !== 'object' || !('errorKey' in error)) return false
  return ['error.tradein.product_not_found', 'error.tradein.category_not_found', 'error.tradein.brand_not_found',
    'error.order.product_not_found', 'error.tradein_order.product_not_found'].includes(String(error.errorKey))
}

export function tradeInPriceLabel(product: { isEnvironmentalOnly: boolean; maxPrice: number },
  translate: (key: string, params?: Record<string, string>) => string, format: (price: number) => string): string {
  if (product.isEnvironmentalOnly) return translate('catalogAvailability.environmental')
  if (product.maxPrice > 0) return translate('sellPage.wizard.upTo') + ' ' + format(product.maxPrice)
  return translate('catalogAvailability.inspectionQuote')
}
